import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
    INIT: 'INIT',
    CLOSE: 'CLOSE',
    SAVE: 'SAVE',
    SAVE_THUMBNAIL: 'SAVE_THUMBNAIL',
}

export const saveAsTemplateEventBroker = new EventBroker();